import { createSlice, Slice } from '@reduxjs/toolkit'

type AppVersionState = {
  initialVersion: string | null
  currentVersion: string | null
}

export const appVersionInitialState: AppVersionState = {
  initialVersion: null,
  currentVersion: null,
}

export const appVersionSlice: Slice<AppVersionState> = createSlice({
  name: 'app-version',
  initialState: appVersionInitialState,
  reducers: {
    recordVersion(state, action: { payload: string }) {
      if (!state.initialVersion) {
        state.initialVersion = action.payload
      }
      state.currentVersion = action.payload
    },
  },
})

export const AppVersionActions = {
  ...appVersionSlice.actions,
}

export const AppVersionReducer = appVersionSlice.reducer
